import { get, post, del, put as update } from "helpers/api_helper";
const getAllRequest = async query => {
  return await get("/api/UnitOfMeasurement/paging", { params: query });
};

export const unitOfMeasurmentService = {
  getAllRequest,
};
